module.exports = {

	/**
	 * Gets the name.
	 *
	 * @return     {string}  The name.
	 */
	getName() {
		return "Юробанк";
	},

	/**
	 * Gets the company full name.
	 *
	 * @return     {string}  The company name.
	 */
	getCompanyName() {
		return "Юробанк България АД";
	},

	/**
	 * Gets the logo.
	 *
	 * @return     {string}  The logo.
	 */
	getLogo() {
		return "images/logos/bnp-pariba.png";
	},

	/**
	 * Gets the agreement file.
	 *
	 * @return     {string}  The agreement file.
	 */
	getAgreementFile() {
		return "https://www.postbank.bg/common-conditions-PFBG";
	},


	/**
	 * Gets the product information file.
	 *
	 * @return     {string}  The product information file.
	 */
	getProductInformationFile() {
		return "https://www.postbank.bg/product-information-PBPG-retailers#_blank";
	},

	/**
	 * Gets the privacy policy file.
	 *
	 * @return     {string}  The privacy policy file.
	 */
	getPrivacyPolicyFile() {
		return "https://www.postbank.bg/Personal-Data-PFBG-retailers";
	},

	/**
	 * Return the summary text.
	 *
     * @param      {number}  months  The months
	 * @param      {number}  price   The price
	 * 
     * @return     	string  The summary text.
	 */

	 summary(months, price) {
		return "<p>Вие избрахте покупка на изплащане с <strong>" + this.getCompanyName() + "</strong>. Обща стойност за плащане: <strong>" + this.total(months, price).toFixed(2) + "</strong> лв., " + months + " месечни вноски по <strong>" + this.perMonth(months, price).toFixed(2) + "</strong> лв. ГПР е <strong>" + this.annualPercentageRate(months, price) + " %</strong>, ГЛП е <strong>" + this.annualInterestRate(months, price) + " %</strong>.</p><p>Кредитни условия на " + this.getCompanyName() + " – <a href='" + this.getAgreementFile() + "' target='_blank'><strong>Условия за кандидатстване за кредит</strong></a> и <a href='" + this.getProductInformationFile() + "' target='_blank'><strong>Продуктова информация</strong></a>. Потвърждавам, че съм прочел и съм запознат с <a href='" + this.getPrivacyPolicyFile() + "' target='_blank'><strong>Информация за защита на личните данни</strong></a>, както и с условията, описани в публикуваните документи, и се съгласявам с тях.</p>";
	},

	/**
	 * Return available periods
	 *
	 * @param      {number}  price   The price
	 * @return     {number}  float
	 */
	availablePeriods(price) {
		if (price <= 249.99) {
			var coefficents = {
				3 : 3.00,
				6 : 6.00,
				9 : 9.00
			};
		} else if (price > 249.99 && price <= 499.99) {
			var coefficents = {
				3 : 3.00,
				6 : 6.00,
				9 : 9.00,
				12: 12.00,
				15: 15.00
			};
		} else if (price > 499.99 && price <= 999.99) {
			var coefficents = {
				3 : 3.00,
				6 : 6.00,
				9 : 9.00,
				12: 12.00,
				15: 15.00,
				18: 18.00,
				24: 24.00
			};
		} else if (price > 999.99 && price <= 12000) {
			var coefficents = {
				3 : 3.00,
				6 : 6.00,
				9 : 9.00,
				12: 12.00,
				15: 15.00,
				18: 18.00,
				24: 24.00,
				36: 36.00
			};
		} else if (price > 12000) {
			var coefficents = {};
		}

		return coefficents;
	},

	/**
	 * Return total price for leasing based on given months period
	 *
	 * @param      {number}  months  The months
	 * @param      {number}  price   The price
	 * @return     {number}  float
	 */
	total(months, price)
	{
        // The key is the months period and the value is the coefficent in %
		var coefficents = this.availablePeriods(price);

        // Формула за изчисляване на вноските: цена Х коефициент = месечна вноска
        if (typeof coefficents[months] !== "undefined") {
            return price + price * (coefficents[months] / 100);
        }

		return null;
        // throw new "Undefined Leasing Period for BNP";
	},

	/**
	 * Returns per month price for leasing based on given months period
	 *
	 * @param      {number}  months  The months
	 * @param      {number}  price   The price
	 * @return     {number}  float
	 */
	perMonth(months, price) 
	{
        return this.total(months, price) / months;
    },

	/**
	 * Returns the annual interest rate ГЛП
	 *
	 * @param      {number}  months  The months
	 * @param      {number}  price   The price
	 * @return     {number}  float
	 */
	annualInterestRate(months, price) 
	{
		var rate = this.rate(months, this.perMonth(months, price), -price);

        return ((rate * 12) * 100).toFixed(2);
	},
	
	/**
	 * Returns the annual percentage rate ГПР
	 *
	 * @param      {number}  months  The months
	 * @param      {number}  price   The price
	 * @return     {number}  float
	 */
	annualPercentageRate(months, price) 
	{
		var glp = this.annualInterestRate(months, price);

        return ((Math.pow(1 + (glp / 12) / 100, 12) - 1) * 100).toFixed(2);
	},

	/**
	 * rate function needed for calculating annual interest rate
	 *
	 * @param      string  months    The date in format d.m.Y
	 * @param      string  perMonth    The date in format d.m.Y
	 * @param      string  total    The date in format d.m.Y
	 *
	 * @return     {float} rate    The rate result
	 */
	rate: function(periods, payment, present, future = 0, type = 0, guess = 0.01) {
	  
		// Set maximum epsilon for end of iteration
		var epsMax = 1e-10;
	  
		// Set maximum number of iterations
		var iterMax = 10;
	  
		// Implement Newton's method
		var y, y0, y1, x0, x1 = 0,
		  f = 0,
		  i = 0;
		var rate = guess;
		if (Math.abs(rate) < epsMax) {
		  y = present * (1 + periods * rate) + payment * (1 + rate * type) * periods + future;
		} else {
		  f = Math.exp(periods * Math.log(1 + rate));
		  y = present * f + payment * (1 / rate + type) * (f - 1) + future;
		}
		y0 = present + payment * periods + future;
		y1 = present * f + payment * (1 / rate + type) * (f - 1) + future;
		i = x0 = 0;
		x1 = rate;
		while ((Math.abs(y0 - y1) > epsMax) && (i < iterMax)) {
		  rate = (y1 * x0 - y0 * x1) / (y1 - y0);
		  x0 = x1;
		  x1 = rate;
			if (Math.abs(rate) < epsMax) {
			  y = present * (1 + periods * rate) + payment * (1 + rate * type) * periods + future;
			} else {
			  f = Math.exp(periods * Math.log(1 + rate));
			  y = present * f + payment * (1 / rate + type) * (f - 1) + future;
			}
		  y0 = y1;
		  y1 = y;
		  ++i;
		}
		return rate;
	}

}